import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
	Card,
	Table,
	Stack,
	Paper,
	Button,
	Avatar,
	TableRow,
	MenuItem,
	TableBody,
	TableCell,
	Container,
	Typography,
	IconButton,
	TableContainer,
	TableHead,
	CircularProgress,
	Box,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { TEAMS } from "src/constants/teams";
import SearchDialog from "../components/pickem-admin/SearchDialog";
import LeagueDialog from "../components/pickem-admin/LeagueDialog";
// ----------------------------------------------------------------------
export default function FriendsLeaguePage() {
	const navigate = useNavigate();
	const [rows, setRows] = useState(null);
	const [openSearchDialog, setOpenSearchDialog] = useState(false);
	const [openLeagueDialog, setOpenLeagueDialog] = useState(false);
	const [editLeague, setEditLeague] = useState(null);
	const [searchLeague, setSearchLeague] = useState(null);
	const [leagueId, setLeagueId] = useState(null);
	useEffect(() => {
		axios
		.get(
			`${process.env.REACT_APP_API_BASE_URL}/admin/leagues/friends?limit=20`
		)
		.then(function (response) {
			setRows(response.data.leagues);
		});
	}, []);

	const successLeagueSearchHandler = (league) => {
		axios
		.get(
			`${process.env.REACT_APP_API_BASE_URL}/admin/league-search?title=${league.title}`,
		)
		.then(function (response) {
			setRows(response.data.league);
		});

	};
	const successLeagueEditHandler=(league)=>{
		axios
		.put(
			`${process.env.REACT_APP_API_BASE_URL}/admin/leagues/${league.league_id}`,
			{...league, league_type:'FRIENDS', league_team_id: null}
		)
		.then(function (response) {
			window.location.reload(false);
		});
	}
	const closeLeagueDialog = () => {
		setEditLeague(null);
		setOpenLeagueDialog(false);
		setOpenSearchDialog(false);
	};
	const openSearchLeagueDialog = () => {
		setEditLeague(null);
		setOpenSearchDialog(true);
	};
	const openEditLeagueDialog = (index) => {
		const league = rows[index];
		setEditLeague(league);
		setOpenLeagueDialog(true);
	};
	return (
		<>
			<Helmet>
				<title>Friends Leagues</title>
			</Helmet>

			<Container>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					mb={5}
				>
					<Typography variant="h4" gutterBottom>
						Friends Leagues
					</Typography>
					<Button
						variant="contained"
						startIcon={<Iconify icon="eva:search-fill" />}
						onClick={() => openSearchLeagueDialog()}
					>
						Search
					</Button>
				</Stack>

				<Card>
					{rows === null ? (
						<Box
							sx={{ display: "flex", justifyContent: "center" }}
							style={{ padding: 20 }}
						>
							<CircularProgress />
						</Box>
					) : (
						<Scrollbar>
							<TableContainer component={Paper}>
								<Table sx={{ minWidth: 650 }} aria-label="simple table">
									<TableHead>
										<TableRow>
											<TableCell>#</TableCell>
											<TableCell>Title</TableCell>
											<TableCell>Type</TableCell>
											<TableCell>Code</TableCell>
											<TableCell>Image</TableCell>
											<TableCell>Image Fr</TableCell>
											<TableCell></TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{rows.map((row, index) => (
											<TableRow
												key={index}
												sx={{
													"&:last-child td, &:last-child th": { border: 0 },
												}}
											>
												<TableCell component="th" scope="row">
													{row.league_id}
												</TableCell>
												<TableCell component="th" scope="row">
													{row.title}
												</TableCell>
												<TableCell component="th" scope="row">
													{row.league_type}
												</TableCell>
												<TableCell component="th" scope="row">
													{row.code}
												</TableCell>
												<TableCell component="th" scope="row">
													<img
														style={{ width: 100 }}
														src={row.league_image_en}
													/>
												</TableCell>
												<TableCell component="th" scope="row">
													<img
														style={{ width: 100 }}
														src={row.league_image_fr}
													/>
												</TableCell>
												<TableCell component="th" scope="row">
													<Iconify
														icon={"eva:calendar-outline"}
														sx={{ cursor: "pointer" }}
														onClick={() =>
															navigate(
																`/dashboard/league-tournaments?league_id=${row.league_id}`
															)
														}
													/>
													<Iconify
														icon={"eva:edit-outline"}
														sx={{ cursor: "pointer" }}
														onClick={() => openEditLeagueDialog(index)}
													/>
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</TableContainer>
						</Scrollbar>
					)}
				</Card>
			</Container>
			<SearchDialog
				league={searchLeague}
				open={openSearchDialog}
				onSuccessHandler={successLeagueSearchHandler}
				onClose={closeLeagueDialog}
			/>
			<LeagueDialog
				league={editLeague}
				open={openLeagueDialog}
				onSuccessHandler={successLeagueEditHandler}
				onClose={closeLeagueDialog}
				isSearch={true}
			/>
		</>
	);
}
